<!-- @format -->

@if (isOk) {
  <div class="badge">
    <sis-icon icon="rule" color="white"></sis-icon>
    <span translate>PLAN_EDIT.SELECTION_ASSISTANT.RULE_HEADER.SELECTIONS_COMPLETE</span>
  </div>
}
<div class="selected float-end">
  <span
    translate="PLAN_EDIT.SELECTION_ASSISTANT.RULE_HEADER.COUNT_STATUS"
    [translateParams]="{ from: selected, to: require | translateRange }">
  </span>
</div>
@if (!isOk && targetRange !== null) {
  <div class="badge">
    <sis-icon icon="rule" color="white"></sis-icon>
    @if (tooFewSelected) {
      <span translate="PLAN_EDIT.SELECTION_ASSISTANT.RULE_HEADER.ITEMS_TO_ADD" [translateParams]="{ range: addRange | translateRange }">
      </span>
    }
    @if (tooManySelected) {
      <span
        translate="PLAN_EDIT.SELECTION_ASSISTANT.RULE_HEADER.ITEMS_TO_REMOVE"
        [translateParams]="{ range: removeRange | translateRange }">
      </span>
    }
  </div>
}
